/* eslint-disable */


/**
 * CBACodes generated from the server.
 *
 * @generator https://test-ir.salaxy.com/v01/api/codes/cba
 * Fetch this data from https://test-ir.salaxy.com/v01/api/codes/cba
 * There is no automatic fetching because the data updated quite seldomly
 */
export const cbaCodes = [
  {
    "code": 1,
    "labelFi": "Ahtausalan teknisten toimihenkilöiden työehtosopimus",
    "labelEn": "Collective Agreement for Technical Salaried Stevedoring Personnel",
    "labelSv": "Kollektivavtal för tekniska tjänstemän i stuveribranschen"
  },
  {
    "code": 2,
    "labelFi": "Ahtausalan toimihenkilöiden työehtosopimus",
    "labelEn": "Collective Agreement for Salaried Employees in the Stedoring Sector",
    "labelSv": "Kollektivavtal för tjänstemän i stuveribranschen"
  },
  {
    "code": 3,
    "labelFi": "Ahtausalan työehtosopimus",
    "labelEn": "Collective Agreement for the Stevedoring Sector",
    "labelSv": "Kollektivavtal för stuveribranschen"
  },
  {
    "code": 4,
    "labelFi": "Ammatillisten aikuiskoulutuskeskusten työehtosopimus",
    "labelEn": "Collective Agreement for Vocational Adult Education Centres",
    "labelSv": "Kollektivavtal för yrkesinriktade vuxenutbildningscenter"
  },
  {
    "code": 5,
    "labelFi": "Ammattikorkeakoulujen opiskelijakuntien työehtosopimus",
    "labelEn": "Collective Agreement for the Student Unions of Universities of Applied Sciences",
    "labelSv": "Kollektivavtalet för yrkeshögskolornas studerandekårer"
  },
  {
    "code": 6,
    "labelFi": "Apteekkien työntekijöiden työehtosopimus",
    "labelEn": "Collective Agreement for Pharmacy Employees",
    "labelSv": "Kollektivavtal för arbetstagare på apotek"
  },
  {
    "code": 10,
    "labelFi": "Arkkitehtisuunnittelualan ylempien toimihenkilöiden työehtosopimus",
    "labelEn": "Collective Agreement for Senior Salaried Employees in the Architectural Sector",
    "labelSv": "Kollektivavtal för högre tjänstemän inom arkitektplaneringsbranschen"
  },
  {
    "code": 11,
    "labelFi": "Asfalttialan työehtosopimus",
    "labelEn": "Collective Agreement for the Asphalting Sector",
    "labelSv": "Kollektivavtal för asfaltbranschen"
  },
  {
    "code": 12,
    "labelFi": "Asiakaspalvelua, liikenteenhoitoa ja -ohjausta sekä hallinnollisia ja muita toimistotehtäviä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Customer Service, Traffic Management and Control and Administrative and Other Office Work",
    "labelSv": "Kollektivavtal gällande kundtjänst, trafikskötsel och -ledning samt administration och andra kontorsuppgifter"
  },
  {
    "code": 13,
    "labelFi": "Autoalan kaupan ja korjaamotoiminnan työehtosopimus",
    "labelEn": "Collective Agreement for Trade and Repair Workshop Activities in the Automotive Sector",
    "labelSv": "Kollektivavtal för handel och verkstadsverksamhet inom bilbranschen"
  },
  {
    "code": 14,
    "labelFi": "Autoalan toimihenkilöitä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Salaried Employees in the Automotive Sector",
    "labelSv": "Kollektivavtal för bilbranschens tjänstemän"
  },
  {
    "code": 15,
    "labelFi": "Autoliikennealojen toimihenkilöitä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Salaried Employees in Road Transport Sectors",
    "labelSv": "Kollektivavtal för tjänstemän i biltrafikbranscherna"
  },
  {
    "code": 16,
    "labelFi": "Autonrengasalan työehtosopimus",
    "labelEn": "Collective Agreement for the Vehicle Tire Sector",
    "labelSv": "Kollektivavtal för bildäcksbranschen"
  },
  {
    "code": 17,
    "labelFi": "Avaintyönantajat AVAINTA ry:n ja Terveys- ja sosiaalialan neuvottelujärjestö TSN ry:n välinen työehtosopimus",
    "labelEn": "Collective Agreement between Avaintyönantajat AVAINTA Association and the TSN Association of the Health and Social Services Sector",
    "labelSv": "Kollektivavtal mellan Serviceinrättningarnas arbetsgivarförening rf och Hälso- och socialvårdens förhandlingsorganisation TSN rf"
  },
  {
    "code": 18,
    "labelFi": "Avaintyönantajat AVAINTA ry:n opetusalan työehtosopimus",
    "labelEn": "Collective Agreement for Education of the Avaintyönantajat AVAINTA Association",
    "labelSv": "Kollektivavtal för AVAINTA Arbetsgivarna rf (Kollektivavtal för undervisningssektorn inom Serviceinrättningarnas arbetsgivarförening)"
  },
  {
    "code": 19,
    "labelFi": "Avaintyönantajat AVAINTA ry:n työehtosopimus",
    "labelEn": "Collective Agreement for the Avaintyönantajat AVAINTA Association",
    "labelSv": "Kollektivavtal gällande Serviceinrättningarnas arbetsgivarförening"
  },
  {
    "code": 20,
    "labelFi": "Bingotyöntekijöitä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Bingo Employees",
    "labelSv": "Kollektivavtal för bingoanställda"
  },
  {
    "code": 21,
    "labelFi": "Bioenergiateollisuuden palveluyritysten työehtosopimus",
    "labelEn": "Collective Agreement for Service Companies in the Bioenergy Industry",
    "labelSv": "Kollektivavtal för serviceföretag inom torv- och pelletindustrin"
  },
  {
    "code": 22,
    "labelFi": "Elintarvikealan automiesten työehtosopimus",
    "labelEn": "Collective Agreement for Road Haulage Workers in the Food Sector",
    "labelSv": "Kollektivavtal för bilmän inom livsmedelsbranschen"
  },
  {
    "code": 23,
    "labelFi": "Elintarviketeollisuusliitto ry:n ja Suomen elintarviketyöläisten liitto SEL ry:n välinen elintarvikealojen työehtosopimus",
    "labelEn": "Collective Agreement for Food Sectors between the Finnish Food and Drink Industries' Federation and the Finnish Food Workers' Union SEL",
    "labelSv": "Kollektivavtal för livsmedelbranschen mellan Finlands livsmedelindustriförbund rf och Finlands livsmedelsarbetareförbund SEL rf"
  },
  {
    "code": 24,
    "labelFi": "Elintarviketeollisuuden sähkömiesten työehtosopimus",
    "labelEn": "Collective Agreement for Electricians in the Food Industry",
    "labelSv": "Kollektivavtal för elektriker inom livsmedelsindustrin"
  },
  {
    "code": 25,
    "labelFi": "Elintarviketeollisuuden toimihenkilöiden työehtosopimus",
    "labelEn": "Collective Agreement for Salaried Employees in the Food Industry",
    "labelSv": "Kollektivavtal för tjänstemän inom livsmedelsindustrin"
  },
  {
    "code": 26,
    "labelFi": "Elokuva- ja tv-tuotantoa koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Cinema and TV Production",
    "labelSv": "Kollektivavtal för film- och tv-produktionen"
  },
  {
    "code": 27,
    "labelFi": "Energiateollisuuden toimihenkilöiden työehtosopimus",
    "labelEn": "Collective Agreement for Salaried Employees in the Energy Industry",
    "labelSv": "Kollektivavtal för tjänstemän i energibranschen"
  },
  {
    "code": 28,
    "labelFi": "Energiateollisuuden ylempien toimihenkilöiden työehtosopimus",
    "labelEn": "Collective Agreement for Senior Salaried Employees in the Energy Industry",
    "labelSv": "Kollektivavtal för högre tjänstemän i energibranschen"
  },
  {
    "code": 29,
    "labelFi": "Ensihoitopalvelualan työehtosopimus ",
    "labelEn": "Collective Agreement for the Emergency Care Services Industry ",
    "labelSv": "Kollektivavtal för den prehospitala akutsjukvården"
  },
  {
    "code": 30,
    "labelFi": "Farmaseuttisen henkilöstön työehtosopimus",
    "labelEn": "Collective Agreement for Pharmaceutical Personnel",
    "labelSv": "Kollektivavtal för farmaceutisk personal"
  },
  {
    "code": 31,
    "labelFi": "Golf-alan työehtosopimus",
    "labelEn": "Collective Agreement for the Golf Sector",
    "labelSv": "Kollektivavtal för golfbranschen"
  },
  {
    "code": 32,
    "labelFi": "Hammaslaboratorioalan työehtosopimus ",
    "labelEn": "Collective Agreement for the Dental Laboratory Sector ",
    "labelSv": "Kollektivavtal för tandlaboratoriebranschen"
  },
  {
    "code": 33,
    "labelFi": "Hammaslääkärien työnantajayhdistys ry:n ja Tehy ry:n välinen työehtosopimus",
    "labelEn": "Collective Agreement between the Employer's Association of Dentists and the Union of Health and Social Care Professionals in Finland",
    "labelSv": "Kollektivavtal för personalen inom munhälsovården"
  },
  {
    "code": 34,
    "labelFi": "Harja- ja sivellinalojen työehtosopimus",
    "labelEn": "Collective Agreement for the Sweeper and Brush Sectors",
    "labelSv": "Kollektivavtal för borst- och penselbranscherna"
  },
  {
    "code": 35,
    "labelFi": "Henkilökohtaisia avustajia koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Personal Assistants",
    "labelSv": "Kollektivavtal för personlig assistans"
  },
  {
    "code": 37,
    "labelFi": "Hiihtokeskusalan työehtosopimus",
    "labelEn": "Collective Agreement for the Skiing Centre Sector",
    "labelSv": "Kollektivavtal för skidcenterbranschen"
  },
  {
    "code": 39,
    "labelFi": "Huolinta-alan toimihenkilöiden työehtosopimus",
    "labelEn": "Collective Agreement for Salaried Employees in the Forwarding Sector",
    "labelSv": "Kollektivavtal för tjänstemän i speditionsbranschen"
  },
  {
    "code": 40,
    "labelFi": "Huolinta-alan varastoterminaali- ja satamatyöntekijöitä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Warehouse Terminal and Port Employees in the Forwarding Sector",
    "labelSv": "Kollektivavtal för lagerterminal- och hamnarbetstagarna inom speditionsbranschen"
  },
  {
    "code": 41,
    "labelFi": "Huolto- ja kunnossapitoalan työehtosopimus",
    "labelEn": "Collective Agreement for the Servicing and Maintenance Sector",
    "labelSv": "Kollektivavtal för service- och underhållsbranschen"
  },
  {
    "code": 42,
    "labelFi": "Huoltokorjaamoiden työehtosopimus",
    "labelEn": "Collective Agreement for Service Workshops",
    "labelSv": "Kollektivavtal för serviceverkstäder"
  },
  {
    "code": 43,
    "labelFi": "Huvi-, teema- ja elämyspuistoja koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Amusement, Theme and Experience Parks",
    "labelSv": "Kollektivavtal som gäller nöjes-, tema- och äventyrsparker"
  },
  {
    "code": 44,
    "labelFi": "ICT-alan työehtosopimus toimihenkilöille",
    "labelEn": "Collective Agreement for Salaried Employees in the ICT Sector",
    "labelSv": "Kollektivavtal för tjänstemän i ICT-branschen"
  },
  {
    "code": 45,
    "labelFi": "ICT-alan työehtosopimus ylemmille toimihenkilöille",
    "labelEn": "Collective Agreement for Senior Salaried Employees in the ICT Sector",
    "labelSv": "Kollektivavtal för högre tjänstemän i ICT-branschen"
  },
  {
    "code": 46,
    "labelFi": "Jakelua koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Deliveries",
    "labelSv": "Kollektivavtal för utdelning"
  },
  {
    "code": 47,
    "labelFi": "Jalometallialan työehtosopimus",
    "labelEn": "Collective Agreement for the Precious Metal Sector",
    "labelSv": "Kollektivavtal för ädelmetallbranschen"
  },
  {
    "code": 48,
    "labelFi": "Kansipäällystöä ja sairaanhoitajia koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Deck Officers and Nurses",
    "labelSv": "Kollektivavtal för däcksbefäl och sjukskötare"
  },
  {
    "code": 49,
    "labelFi": "Kaupan automiesten työehtosopimus",
    "labelEn": "Collective Agreement for Commercial Road Haulage Workers",
    "labelSv": "Kollektivavtal för chaufförer inom handelsbranschen"
  },
  {
    "code": 50,
    "labelFi": "Kaupan työehtosopimus",
    "labelEn": "Collective Agreement for Trade",
    "labelSv": "Handelns kollektivavtal"
  },
  {
    "code": 51,
    "labelFi": "Kemian perusteollisuuden työehtosopimus",
    "labelEn": "Collective Agreement for Basic Chemical Industry",
    "labelSv": "Kollektivavtal för den kemiska basindustrin"
  },
  {
    "code": 52,
    "labelFi": "Kemianalan toimihenkilösopimus",
    "labelEn": "Agreement for Salaried Employees in the Chemical Sector",
    "labelSv": "Kollektivavtal för tjänstemän inom den kemiska branschen"
  },
  {
    "code": 53,
    "labelFi": "Kemianteollisuuden ylempien toimihenkilöiden pöytäkirja",
    "labelEn": "Protocol for Senior Salaried Employees in the Chemical Industry",
    "labelSv": "Protokoll gällande högre tjänstemän inom kemiindustrin"
  },
  {
    "code": 54,
    "labelFi": "Kenkä- ja nahkateollisuuden ja kultaseppäteollisuuden sekä harja- ja sivellinalojen toimihenkilösopimus",
    "labelEn": "Agreement for Salaried Employees in the Leather and Shoe Industry, the Goldsmith Industry and the Sweeper and Brush Sectors",
    "labelSv": "Tjänstemannaavtal för sko- och läderindustrin och guldsmedsindustrin samt borst- och penselbranschen"
  },
  {
    "code": 55,
    "labelFi": "Kenkä- ja nahkateollisuuden työehtosopimus",
    "labelEn": "Collective Agreement for the Shoe and Leather Industry",
    "labelSv": "Kollektivavtal för sko- och läderindustrin"
  },
  {
    "code": 56,
    "labelFi": "Kiinteistöalan toimihenkilöitä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Salaried Employees in the Real Property Sector",
    "labelSv": "Kollektivavtal för tjänstemän i fastighetsbranschen"
  },
  {
    "code": 57,
    "labelFi": "Kiinteistöpalvelualan työntekijöitä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Employees in the Real Property Services Sector",
    "labelSv": "Kollektivavtal för arbetstagare i fastighetsservicebranschen"
  },
  {
    "code": 58,
    "labelFi": "Konepäällystöä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Engine Officers",
    "labelSv": "Kollektivavtal för maskinbefäl"
  },
  {
    "code": 60,
    "labelFi": "Kotimaan matkustaja-alusliikenteen työehtosopimus",
    "labelEn": "Collective Agreement for Domestic Passenger Vessel Traffic",
    "labelSv": "Kollektivavtal för passagerarfartyg i inrikestrafiken"
  },
  {
    "code": 61,
    "labelFi": "Kotitalouskone- ja kodintekniikkahuoltoa sekä palveluautomaattialaa koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Domestic Appliance and Home Technology Service and the Service Automation Sector",
    "labelSv": "Kollektivavtal för hushållsmaskin- och hemelektronikservice samt serviceautomatbranschen"
  },
  {
    "code": 62,
    "labelFi": "Kristillisiä järjestöjä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Christian Organisations",
    "labelSv": "Kollektivavtal för kristliga organisationer"
  },
  {
    "code": 63,
    "labelFi": "Kemianteollisuus ry:n, Kumiteollisuus ry:n ja Sähköalojen ammattiliitto ry:n välinen sähköalan työntekijöiden työehtosopimus",
    "labelEn": "Collective Agreement for Electrical Employees between the Chemical Industry Federation of Finland, the Rubber Manufacturers' Association of Finland and the Finnish Electrical Workers' Union",
    "labelSv": "Kollektivavtal mellan Kemiindustrin rf, Gummiindustrin rf och Elbranschernas fackförbund rf för arbetstagare i elbranschen"
  },
  {
    "code": 64,
    "labelFi": "Kumiteollisuuden toimihenkilöiden työehtosopimus",
    "labelEn": "Collective Agreement for Salaried Employees in the Rubber Industry",
    "labelSv": "Kollektivavtal för tjänstemän inom gummiindustrin"
  },
  {
    "code": 65,
    "labelFi": "Kumiteollisuuden työntekijöitä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Employees in the Rubber Industry",
    "labelSv": "Kollektivavtal för arbetstagare inom gummiindustrin"
  },
  {
    "code": 66,
    "labelFi": "Kuorma-autoalan työehtosopimus",
    "labelEn": "Collective Agreement for Truck Drivers",
    "labelSv": "Kollektivavtal för lastbilsbranschen"
  },
  {
    "code": 67,
    "labelFi": "Kuvanvalmistamoita koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Photographic Development Studios",
    "labelSv": "Kollektivavtal för bildframställningsbranschen"
  },
  {
    "code": 68,
    "labelFi": "Lasikeraamisen teollisuuden sähkömiesten työehtosopimus",
    "labelEn": "Collective Agreement for Electricians in the Glass-Ceramic Industry",
    "labelSv": "Kollektivavtal för elektriker inom den glaskeramiska industrin"
  },
  {
    "code": 69,
    "labelFi": "Lasikeraamisen teollisuuden toimihenkilöitä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Salaried Employees in the Glass-Ceramic Industry",
    "labelSv": "Kollektivavtal för tjänstemän inom den glaskeramiska industrin"
  },
  {
    "code": 70,
    "labelFi": "Lasikeraamisen teollisuuden työehtosopimus",
    "labelEn": "Collective Agreement for the Glass-Ceramic Industry",
    "labelSv": "Kollektivavtal för den glaskeramiska industrin"
  },
  {
    "code": 71,
    "labelFi": "Lasitus-, rakennuslasitus- ja lasinjalostusalan työehtosopimus",
    "labelEn": "Collective Agreement for the Glazing, Building Glazing and Glass Processing Industry",
    "labelSv": "Kollektivavtal för glasnings-, byggnadsglasnings- och glasförädlingsindustrin"
  },
  {
    "code": 72,
    "labelFi": "Lattianpäällystysalan työehtosopimus",
    "labelEn": "Collective Agreement for the Flooring Industry",
    "labelSv": "Kollektivavtal för golvbeläggningsbranschen"
  },
  {
    "code": 73,
    "labelFi": "Losseja koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Cable Ferries",
    "labelSv": "Kollektivavtal för färjör mellan Arbetsgivarna för servicebranscherna PALTA rf samt Förbundet för den offentliga sektorn och välfärdsområdena JHL rf och Finlands Sjömans-Union FSU rf"
  },
  {
    "code": 74,
    "labelFi": "Leipomoiden työntekijöitä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Bakery Employees",
    "labelSv": "Kollektivavtal för bageriarbetstagare"
  },
  {
    "code": 75,
    "labelFi": "Lentoliikenteen palveluja koskeva työehtosopimus ",
    "labelEn": "Collective Agreement for Air Transport Services ",
    "labelSv": "Kollektivavtal gällande tjänster inom flygtrafiken"
  },
  {
    "code": 76,
    "labelFi": "Lentoliikenteen toimihenkilöitä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Salaried Employees in Air Transport",
    "labelSv": "Kollektivavtal för tjänstemän inom flygtrafiken"
  },
  {
    "code": 77,
    "labelFi": "Liha-alan työehtosopimus",
    "labelEn": "Collective Agreement for the Meat Industry",
    "labelSv": "Kollektivavtal för köttbranschen"
  },
  {
    "code": 79,
    "labelFi": "Liikenneopetusalan työehtosopimus",
    "labelEn": "Collective Agreement for the Driving Instructor Industry",
    "labelSv": "Kollektivavtal för trafikundervisningsbranschen"
  },
  {
    "code": 80,
    "labelFi": "Linja-autohenkilökunnan työehtosopimus",
    "labelEn": "Collective Agreement for the Bus and Coach Personnel",
    "labelSv": "Kollektivavtal för busspersonalen"
  },
  {
    "code": 81,
    "labelFi": "Luottotieto- ja perintäalan työehtosopimus",
    "labelEn": "Collective Agreement for the Credit Information and Debt Recovery Sector",
    "labelSv": "Kollektivavtal för kreditupplysnings- och inkassobranschen"
  },
  {
    "code": 82,
    "labelFi": "Infra-alan työehtosopimus",
    "labelEn": "Collective agreement for the infrastructural sector",
    "labelSv": "Infrastrukturbranschens kollektivavtal"
  },
  {
    "code": 83,
    "labelFi": "Maalausalan työehtosopimus urakkahinnoitteluineen",
    "labelEn": "Collective Agreement for the Painting Sector, with Contract Rates",
    "labelSv": "Kollektivavtal för målningsbranschen inklusive entreprenadprissättning"
  },
  {
    "code": 84,
    "labelFi": "Maarakennusalan työehtosopimus (Koneyrittäjien liitto)",
    "labelEn": "Collective Agreement for the Earthworks Sector (the Trade Association of Finnish Forestry and Earth Moving Contractors)",
    "labelSv": "Kollektivavtal för markbyggnadsbranschen (Maskinföretagarnas förbund)"
  },
  {
    "code": 85,
    "labelFi": "Maaseutuelinkeinojen työehtosopimus",
    "labelEn": "Collective Agreement for Rural Industries",
    "labelSv": "Kollektivavtal för landsbygdsnäringarna"
  },
  {
    "code": 87,
    "labelFi": "Malmikaivosten työehtosopimus",
    "labelEn": "Collective Agreement for Ore Mines",
    "labelSv": "Kollektivavtal för arbetstagare i malmgruvor"
  },
  {
    "code": 89,
    "labelFi": "Matkailu-, ravintola ja vapaa-ajan palveluita koskeva työehtosopimus - työntekijät",
    "labelEn": "Collective Agreement for Tourism, Restaurant and Recreational Services - Employees",
    "labelSv": "Kollektivavtal för arbetstagare i branschen för turism-, restaurang- och fritidstjänster"
  },
  {
    "code": 90,
    "labelFi": "Matkatoimistoja koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Travel Agencies",
    "labelSv": "Kollektivavtal för resebyråer"
  },
  {
    "code": 91,
    "labelFi": "Matkustamohenkilöstöä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Cabin Crew",
    "labelSv": "Kollektivavtal för kabinpersonal"
  },
  {
    "code": 92,
    "labelFi": "Meijereiden erikoiskoulutuksen saaneiden ja teknisten toimihenkilöiden työehtosopimus ",
    "labelEn": "Collective Agreement for Salaried Employees with Special or Technical Education in Dairies ",
    "labelSv": "Kollektivavtal för meijeriernas specialutbildade och tekniska funktionärer"
  },
  {
    "code": 93,
    "labelFi": "Meijerityöntekijöitä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Dairy Employees",
    "labelSv": "Kollektivavtal för mejeriarbetstagare"
  },
  {
    "code": 98,
    "labelFi": "Metsäalan työehtosopimus",
    "labelEn": "Collective Agreement for the Forestry Sector",
    "labelSv": "Kollektivavtal för skogsbranschen"
  },
  {
    "code": 99,
    "labelFi": "Metsäkonealan työehtosopimus",
    "labelEn": "Collective Agreement for the Forestry Machine Sector",
    "labelSv": "Kollektivavtal för skogsmaskinbranschen"
  },
  {
    "code": 100,
    "labelFi": "Metsänhoitoyhdistysten toimihenkilöitä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Salaried Employees in Forest Management Associations",
    "labelSv": "Kollektivavtal för skogsvårdsföreningarnas tjänstemän"
  },
  {
    "code": 103,
    "labelFi": "Muovituoteteollisuuden ja kemian tuoteteollisuuden työehtosopimus",
    "labelEn": "Collective Agreement for the Plastics Product Industry and the Chemical Product Industry",
    "labelSv": "Kollektivavtal för plastproduktindustrin och kemiproduktindustrin"
  },
  {
    "code": 104,
    "labelFi": "Museoiden työehtosopimus",
    "labelEn": "Collective Agreement for Museums",
    "labelSv": "Kollektivavtal gällande museer"
  },
  {
    "code": 105,
    "labelFi": "Neuvonta-alan runkosopimus",
    "labelEn": "Framework Agreement for the Counselling Sector",
    "labelSv": "Ramavtal för rådgivningsbranschen"
  },
  {
    "code": 106,
    "labelFi": "Näyttelijöiden teatterityöehtosopimus",
    "labelEn": "Collective Agreement for Theatrical Actors",
    "labelSv": "Kollektivavtal för skådespelare"
  },
  {
    "code": 107,
    "labelFi": "Ohjelmapalvelualan työehtosopimus",
    "labelEn": "Collective Agreement for the Programme Services Industry",
    "labelSv": "Kollektivavtal för programservicebranschen"
  },
  {
    "code": 108,
    "labelFi": "Optikoiden työehtosopimus",
    "labelEn": "Collective Agreement for Opticians",
    "labelSv": "Kollektivavtal för optiker"
  },
  {
    "code": 110,
    "labelFi": "Pahvin- ja paperinjalostusalan toimihenkilöiden työehtosopimus",
    "labelEn": "Collective Agreement for Salaried Employees in the Board and Paper Processing Sector",
    "labelSv": "Kollektivavtal för tjänstemän inom kartong- och pappersförädlingsbranschen"
  },
  {
    "code": 111,
    "labelFi": "Pahvin- ja paperinjalostusalan työehtosopimus",
    "labelEn": "Collective Agreement for the Board and Paper Processing Sector",
    "labelSv": "Kollektivavtal för kartong- och pappersförädlingsbranschen"
  },
  {
    "code": 113,
    "labelFi": "PALTAn toimihenkilöitä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Palta's Salaried Employees",
    "labelSv": "Kollektivavtal för tjänstemän hos medlemsföretag i PALTA"
  },
  {
    "code": 116,
    "labelFi": "Panimoiden ja virvoitusjuomatehtaiden työehtosopimus",
    "labelEn": "Collective Agreement for Breweries and Beverage Plants",
    "labelSv": "Kollektivavtal för bryggerier och läskedrycksfabriker"
  },
  {
    "code": 119,
    "labelFi": "Pelti- ja teollisuuseristysalan työehtosopimus",
    "labelEn": "Collective Agreement for the Sheet Metal and Industrial Insulation Sector",
    "labelSv": "Kollektivavtal för plåt- och industriisoleringsbranschen"
  },
  {
    "code": 120,
    "labelFi": "Puusepänteollisuuden toimihenkilöiden työehtosopimus",
    "labelEn": "Collective Agreement for Salaried Employees in the Carpentry Industry",
    "labelSv": "Kollektivavtal för tjänstemän inom snickeriindustrin"
  },
  {
    "code": 121,
    "labelFi": "Puusepänteollisuuden työehtosopimus",
    "labelEn": "Collective Agreement for the Carpentry Industry",
    "labelSv": "Kollektivavtal för snickeriindustrin"
  },
  {
    "code": 122,
    "labelFi": "Puutarha-alan työehtosopimus",
    "labelEn": "Collective Agreement for the Gardening Sector",
    "labelSv": "Kollektivavtal för trädgårdsbranschen"
  },
  {
    "code": 124,
    "labelFi": "Rahoitusalan siivoojia koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Cleaners in the Financial Sector",
    "labelSv": "Kollektivavtal för städare i finansieringsbranschen"
  },
  {
    "code": 125,
    "labelFi": "Rahoitusalan työehtosopimus",
    "labelEn": "Collective Agreement for the Financial Sector",
    "labelSv": "Kollektivavtal för finansbranschen"
  },
  {
    "code": 126,
    "labelFi": "Rakennusaine- ja betoniteollisuuden toimihenkilöitä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Salaried Employees in the Construction Material and Concrete Industry",
    "labelSv": "Kollektivavtal för tjänstemän i byggämnes- och betongindustrin"
  },
  {
    "code": 127,
    "labelFi": "Rakennusalan toimihenkilöiden työehtosopimus",
    "labelEn": "Collective Agreement for Salaried Employees in the Construction Sector",
    "labelSv": "Kollektivavtal för tjänstemän i byggbranschen"
  },
  {
    "code": 128,
    "labelFi": "Rakennusalan työehtosopimus urakkahinnoitteluineen",
    "labelEn": "Collective Agreement for the Construction Sector, with Contract Rates",
    "labelSv": "Kollektivavtal för byggbranschen"
  },
  {
    "code": 129,
    "labelFi": "Rakennustuoteteollisuuden työehtosopimus",
    "labelEn": "Collective Agreement for the Construction Product Industry",
    "labelSv": "Kollektivavtal för byggproduktindustrin"
  },
  {
    "code": 130,
    "labelFi": "Rautatiealan työehtosopimus",
    "labelEn": "Collective Agreement for the Railway Sector",
    "labelSv": "Kollektivavtal för järnvägsbranschen"
  },
  {
    "code": 131,
    "labelFi": "Seminologien ja keinosiemennysasemien työehtosopimus ",
    "labelEn": "Collective Agreement for Seminologists and Artificial Insemination Stations ",
    "labelSv": "Kollektivavtal för seminologer och stationer för artificiell"
  },
  {
    "code": 132,
    "labelFi": "Sosiaalialan järjestöjä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Social Services Organisations",
    "labelSv": "Kollektivavtal för organisationer inom det sociala området"
  },
  {
    "code": 133,
    "labelFi": "Suunnittelu- ja konsulttialan toimihenkilöiden työehtosopimus",
    "labelEn": "Collective Agreement for Salaried Employees in the Design and Consultancy Sector",
    "labelSv": "Kollektivavtal för tjänstemän I planerings- och konsultbranschen"
  },
  {
    "code": 134,
    "labelFi": "Suunnittelu- ja konsulttialan ylempien toimihenkilöiden työehtosopimus",
    "labelEn": "Collective Agreement for Senior Salaried Employees in the Design and Consultancy Sector",
    "labelSv": "Kollektivavtal för högre tjänstemän i planerings- och konsultbranschen"
  },
  {
    "code": 135,
    "labelFi": "Sähköalan tes - energia - ICT - verkosto -työehtosopimus ",
    "labelEn": "Collective Agreement for the Electricity Sector - Energy - ICT - Network - Collective Agreement ",
    "labelSv": "Kollektivavtal för elbranschen - energi - ICT - nätverk"
  },
  {
    "code": 136,
    "labelFi": "Sähköistys- ja sähköasennusalan työehtosopimus",
    "labelEn": "Collective Agreement for the Electrification and Electrical Installations Sector",
    "labelSv": "Kollektivavtal för elektrifierings- och elinstallationsbranchen"
  },
  {
    "code": 137,
    "labelFi": "Säiliöauto- ja öljytuotealaa sekä niihin liittyviä toimintoja koskeva työehtosopimus",
    "labelEn": "Collective Agreement for the Tank Truck and Oil Product Sector and Related Functions",
    "labelSv": "Kollektivavtal för tankbil- och oljeproduktbranschen och för funktioner med anknytning till dessa"
  },
  {
    "code": 138,
    "labelFi": "Taimitarha-alan työehtosopimus",
    "labelEn": "Collective Agreement for the Nursery Garden Sector",
    "labelSv": "Kollektivavtal för plantskolebranschen"
  },
  {
    "code": 139,
    "labelFi": "Taksiliikenteen työehtosopimus",
    "labelEn": "Collective Agreement for Taxi Transport",
    "labelSv": "Kollektivavtal gällande taxitrafiken"
  },
  {
    "code": 140,
    "labelFi": "Talotekniikka-alan LVI-toimialan työehtosopimus",
    "labelEn": "Collective Agreement for the HVAC Sector of Building Services Engineering",
    "labelSv": "Kollektivavtal för VVS-branschen inom husteknikbranschen"
  },
  {
    "code": 142,
    "labelFi": "Talotekniikka-alan toimihenkilöiden työehtosopimus",
    "labelEn": "Collective Agreement for Salaried Employees in the Building Services Engineering Sector",
    "labelSv": "Kollektivavtal för tjänstemän i husteknikbranschen"
  },
  {
    "code": 143,
    "labelFi": "Taloushallintoalaa koskeva työehtosopimus",
    "labelEn": "Collective Agreement for the Financial Management Sector",
    "labelSv": "Kollektivavtal för ekonomiförvaltningsbranschen"
  },
  {
    "code": 144,
    "labelFi": "Tanssinopettajien työehtosopimus",
    "labelEn": "Collective Agreement for Dance Instructors",
    "labelSv": "Kollektivavtal för danslärare"
  },
  {
    "code": 145,
    "labelFi": "Teatterialan työehtosopimus",
    "labelEn": "Collective Agreement for the Theatre Sector",
    "labelSv": "Kollektivavtal för teaterbranschen"
  },
  {
    "code": 146,
    "labelFi": "Teknisen huollon ja kunnossapidon työehtosopimus",
    "labelEn": "Collective Agreement for Technical Servicing and Maintenance",
    "labelSv": "Kollektivavtal för tekniska service- och underhållsuppgifter"
  },
  {
    "code": 148,
    "labelFi": "Teknologiateollisuuden toimihenkilöiden työehtosopimus",
    "labelEn": "Collective Agreement for Salaried Employees in the Technology Industry",
    "labelSv": "Kollektivavtal för tjänstemän inom teknologiindustrin"
  },
  {
    "code": 150,
    "labelFi": "Teknologiateollisuuden ylempien toimihenkilöiden työehtosopimus",
    "labelEn": "Collective Agreement for Senior Salaried Employees in the Technology Industry",
    "labelSv": "Kollektivavtal för teknologiindustrins högre tjänstemän"
  },
  {
    "code": 151,
    "labelFi": "Tekstiilihuoltoalan työehtosopimus ",
    "labelEn": "Collective Agreement for the Textile Care Sector ",
    "labelSv": "Kollektivavtal för textilservicebranschen"
  },
  {
    "code": 152,
    "labelFi": "Tekstiili- ja muotialan toimihenkilösopimus",
    "labelEn": "Agreement for Salaried Employees in the Textile and Fashion Sector",
    "labelSv": "Kollektivavtal för tjänstemän i textil- och modelbranchen"
  },
  {
    "code": 153,
    "labelFi": "Tekstiili- ja muotialan työehtosopimus ",
    "labelEn": "Collective Agreement for the Textile and Fashion Sector ",
    "labelSv": "Kollektivavtal för textil- och modebranchen"
  },
  {
    "code": 154,
    "labelFi": "Terminaalitoimintaa koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Terminal Operations",
    "labelSv": "Kollektivavtal gällande terminalverksamhet"
  },
  {
    "code": 155,
    "labelFi": "Terveyspalvelualan työehtosopimus",
    "labelEn": "Collective Agreement for the Health Services Sector",
    "labelSv": "Kollektivavtal för hälsovårdsbranchen"
  },
  {
    "code": 156,
    "labelFi": "Terveyspalvelualan työehtosopimus (Unioni) ",
    "labelEn": "Collective Agreement for the Health Services Sector (Union) ",
    "labelSv": "Kollektivavtal gällande hälsoservicebranschen (Unioni)"
  },
  {
    "code": 157,
    "labelFi": "Tietotekniikan palvelualan työehtosopimus",
    "labelEn": "Collective Agreement for the Information Technology Services Sector",
    "labelSv": "Kollektivavtal för den datatekniska servicebranschen"
  },
  {
    "code": 158,
    "labelFi": "Tilapäisten teatterimuusikkojen työehtosopimus",
    "labelEn": "Collective Agreement for Temporary Theatre Musicians",
    "labelSv": "Kollektivavtal för tillfälliga teatermusiker"
  },
  {
    "code": 159,
    "labelFi": "Turkistuotantoalan työehtosopimus",
    "labelEn": "Collective Agreement for the Fur Production Sector",
    "labelSv": "Kollektivavtal för pälsproduktion"
  },
  {
    "code": 160,
    "labelFi": "Turvetuotantoalan työehtosopimus",
    "labelEn": "Collective Agreement for the Peat Mining Sector",
    "labelSv": "Kollektivavtal för torvproduktionsbranschen"
  },
  {
    "code": 162,
    "labelFi": "Ulkomaanliikenteen kauppa-aluksia koskeva työehtosopimus ",
    "labelEn": "Collective Agreement for Merchant Vessels in International Traffic ",
    "labelSv": "Kollektivavtal för utrikesfartens handelsfartyg"
  },
  {
    "code": 163,
    "labelFi": "Ulkomaanliikenteen matkustaja-alussopimus",
    "labelEn": "Agreement for Passenger Vessels in International Traffic",
    "labelSv": "Kollektivavtal för passagerarfartyg i utrikestrafik"
  },
  {
    "code": 164,
    "labelFi": "Ulkomaanliikenteen pientonniston kansipäällystöä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for the Deck Officers of Small-Tonnage Vessels in International Traffic",
    "labelSv": "Kollektivavtal för småtonnage i utrikesfart som gäller däcksbefäl"
  },
  {
    "code": 165,
    "labelFi": "Ulkomaanliikenteen pientonniston konepäällystöä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for the Engine Officers of Small-Tonnage Vessels in International Traffic",
    "labelSv": "Kollektivavtal för småtonnage i utrikesfart som gäller maskinbefäl"
  },
  {
    "code": 166,
    "labelFi": "Urheilujärjestöjen valmentajia koskeva työehtosopimus",
    "labelEn": "Collective Agreement for the Coaches of Sports Organisations",
    "labelSv": "Kollektivavtal för tränare i idrottsorganisationer"
  },
  {
    "code": 167,
    "labelFi": "Urheilujärjestöjä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Sports Organisations",
    "labelSv": "Kollektivavtal gällande idrottsorganisationer"
  },
  {
    "code": 168,
    "labelFi": "Vakinaisten teatterimuusikkojen työehtosopimus",
    "labelEn": "Collective Agreement for Permanent Theatre Musicians",
    "labelSv": "Kollektivavtal för ordinarie teatermusiker"
  },
  {
    "code": 169,
    "labelFi": "Vakuutusalan työehto- ja palkkasopimukset",
    "labelEn": "Collective and Salary Agreements for the Insurance Sector",
    "labelSv": "Försäkringsbranschens kollektiv- och löneavtal"
  },
  {
    "code": 171,
    "labelFi": "Vartiointialan työehtosopimus",
    "labelEn": "Collective Agreement for the Security Services Sector",
    "labelSv": "Kollektivavtal för bevakningsbranschen"
  },
  {
    "code": 172,
    "labelFi": "Vedeneristysalan työehtosopimus",
    "labelEn": "Collective Agreement for the Waterproofing Sector",
    "labelSv": "Kollektivavtal för vattenisoleringsbranschen"
  },
  {
    "code": 173,
    "labelFi": "Veneenrakennusteollisuuden työehtosopimus",
    "labelEn": "Collective Agreement for the Boat Construction Industry",
    "labelSv": "Kollektivavtal för båtbyggnadsindustrin"
  },
  {
    "code": 174,
    "labelFi": "Veturimiestehtäviä rautatieliikenteessä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Train Driver Duties in Rail Traffic",
    "labelSv": "Kollektivavtal för lokmannauppgifter inom järnvägstrafiken"
  },
  {
    "code": 175,
    "labelFi": "Medialiiton ja Ammattiliitto Pron välinen toimihenkilöiden työehtosopimus",
    "labelEn": "Collective Agreement for Salaried Employees between the Finnish Media Federation and Trade Union Pro",
    "labelSv": "Kollektivavtal för tjänstemän mellan Medieförbundet rf och Fackförbundet Pro"
  },
  {
    "code": 176,
    "labelFi": "Medialiiton ja Ammattiliitto Pron välinen viestintäalan teknisiä toimihenkilöitä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Technical Salaried Communication Employees between the Finnish Media Federation and Trade Union Pro",
    "labelSv": "Kollektivavtal för tekniska tjänstemän mellan Medieförbundet och Fackförbundet Pro"
  },
  {
    "code": 177,
    "labelFi": "Medialiiton ja Suomen Journalistiliiton välinen kustannustoimittajien työehtosopimus",
    "labelEn": "Collective Agreement for Editors between the Finnish Media Federation and the Union of Journalists in Finland",
    "labelSv": "Kollektivavtal för förlagsredaktörer mellan Mediernas cetralförbund och Finlands Journalistförbund"
  },
  {
    "code": 178,
    "labelFi": "Medialiiton ja Suomen Journalistiliiton välinen työehtosopimus",
    "labelEn": "Collective Agreement between the Finnish Media Federation and the Union of Journalists in Finland",
    "labelSv": "Kollektivavtal mellan Medieförbundet och Finlands journalistförbund"
  },
  {
    "code": 179,
    "labelFi": "Medialiiton ja Teollisuusliiton sekä Viestintäalan toimihenkilöt Grafinet ry:n välinen toimihenkilöitä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Salaried Employees between the Finnish Media Federation, the Industrial Union and the Grafinet Association for Salaried Employees in the Media Industry",
    "labelSv": "Kollektivavtal för tjänstemän mellan Medieförbundet och Industrifacket samt Viestintäalan toimihenkilöt Grafinet ry"
  },
  {
    "code": 180,
    "labelFi": "Medialiiton ja Teollisuusliiton välinen media- ja painoalan työntekijöitä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Employees in the Media and Printing Industries between the Finnish Media Federation and the Industrial Union",
    "labelSv": "Kollektivavtal för arbetstargare inom medie- och tryckeribranchen mellan Medieförbundet och Industrifacket"
  },
  {
    "code": 181,
    "labelFi": "Viestinvälitys- ja logistiikka-alan työehtosopimus",
    "labelEn": "Collective Agreement for the Messaging and Logistics Sector",
    "labelSv": "Kollektivavtal för kommunikationsförmedlings- och logistikbranschen"
  },
  {
    "code": 182,
    "labelFi": "Viestinvälitys- ja logistiikka-alan ylempien toimihenkilöiden työehtosopimus",
    "labelEn": "Collective Agreement for Senior Salaried Employees in the Messaging and Logistics Sector",
    "labelSv": "Kollektivavtal för högre tjänstemän i kommunikationsförmedlings- och logistikbranschen"
  },
  {
    "code": 183,
    "labelFi": "Viher- ja ympäristörakentamisalan työehtosopimus ",
    "labelEn": "Collective Agreement for Green Area and Environmental Construction Sector ",
    "labelSv": "Kollektivavtal för grön- och miljöanläggningsbranschen"
  },
  {
    "code": 186,
    "labelFi": "Yksityisen laboratorioalan toimihenkilöiden työehtosopimus",
    "labelEn": "Collective Agreement for Salaried Employees in the Private Laboratory Sector",
    "labelSv": "Kollektivavtal för tjänstemän inom den privata laboratoriebranschen"
  },
  {
    "code": 187,
    "labelFi": "Yksityisen opetusalan työehtosopimus",
    "labelEn": "Collective Agreement for the Private Education Sector",
    "labelSv": "Kollektivavtal för den privata undervisningssektorn"
  },
  {
    "code": 188,
    "labelFi": "Yksityisen sosiaalipalvelualan työehtosopimus",
    "labelEn": "Collective Agreement for the Private Social Services Sector",
    "labelSv": "Kollektivavtal för den privata socialservicebranschen"
  },
  {
    "code": 189,
    "labelFi": "Yliopistojen yleinen työehtosopimus",
    "labelEn": "General Collective Agreement for Universities",
    "labelSv": "Allmänt kollektivavtal för universitet"
  },
  {
    "code": 190,
    "labelFi": "Ylioppilaskuntien työehtosopimus",
    "labelEn": "Collective Agreement for Student Unions",
    "labelSv": "Kollektivavtal för studentkårer"
  },
  {
    "code": 191,
    "labelFi": "Yrityskehitysorganisaatioiden työehtosopimus",
    "labelEn": "Collective Agreement for Business Development Organisations",
    "labelSv": "Kollektivavtal för organisationer inom företagsutvecklingen"
  },
  {
    "code": 192,
    "labelFi": "Äänilevytuottajayhtiöiden palveluksessa olevia muusikkoja, laulajia ja kapellimestareita koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Musicians, Singers and Conductors in the Service of Record Producer Companies",
    "labelSv": "Kollektivavtal för musiker, sångare och kapellmästare i tjänst hos skivproducentbolag"
  },
  {
    "code": 193,
    "labelFi": "Öljy-, maakaasu- ja petrokemianteollisuuden työehtosopimus",
    "labelEn": "Collective Agreement for the Oil, Natural Gas and Petrochemical Industry",
    "labelSv": "Kollektivavtal för olje-, naturgas- och petrokemiska industrin"
  },
  {
    "code": 194,
    "labelFi": "Muu työehtosopimus",
    "labelEn": "Other collective agreement",
    "labelSv": "Annat kollektivavtal"
  },
  {
    "code": 195,
    "labelFi": "Alalla ei ole valtakunnallista työehtosopimusta",
    "labelEn": "No national collective agreement for the field",
    "labelSv": "Branschen saknar riksomfattande kollektivavtal"
  },
  {
    "code": 196,
    "labelFi": "Kunnan työehtosopimukset",
    "labelEn": "Municipal collective agreements",
    "labelSv": "Kommunens kollektivavtal"
  },
  {
    "code": 197,
    "labelFi": "Valtion työehtosopimukset",
    "labelEn": "State collective agreements",
    "labelSv": "Statens kollektivavtal"
  },
  {
    "code": 198,
    "labelFi": "Kirkon työehtosopimukset",
    "labelEn": "Church collective agreements",
    "labelSv": "Kyrkans kollektivavtal"
  },
  {
    "code": 199,
    "labelFi": "Asiakaspalvelu- ja telemarkkinointialaa koskeva työehtosopimus",
    "labelEn": "Collective Agreement for the Customer Service and Telemarketing Sector",
    "labelSv": "Kollektivavtal för kundservice- och telemarketingbranschen"
  },
  {
    "code": 200,
    "labelFi": "Avaintyönantajat AVAINTA ry:n ja Suomen Muusikkojen liiton välinen työehtosopimus",
    "labelEn": "Collective Agreement between Avaintyönantajat AVAINTA Association and the Finnish Musicians’ Union",
    "labelSv": "Kollektivavtal mellan AVAINTA Arbetsgivarna rf och och Finlands musikers förbund rf"
  },
  {
    "code": 201,
    "labelFi": "Elokuvateattereita koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Cinemas",
    "labelSv": "Kollektivavtal för biografteatrar"
  },
  {
    "code": 202,
    "labelFi": "Huolto- ja kunnossapitopalvelualan työehtosopimus ylemmille toimihenkilöille",
    "labelEn": "Collective Agreement for Senior Salaried Employees in the Repair and Maintenance Service Sector",
    "labelSv": "Kollektivavtal för högre tjänstemän i service- och underhållsbranschen"
  },
  {
    "code": 204,
    "labelFi": "Muuttopalvelualan työehtosopimus",
    "labelEn": "Collective Agreement for the Removal Services Sector",
    "labelSv": "Kollektivavtal för flyttservicebranschen"
  },
  {
    "code": 207,
    "labelFi": "Tarkastusalan työehtosopimus",
    "labelEn": "Collective Agreement for the Inspection Sector",
    "labelSv": "Kollektivavtal för inspektionsbranschen"
  },
  {
    "code": 208,
    "labelFi": "Rakennustuoteteollisuuden sähkömiesten työehtosopimus",
    "labelEn": "Collective Agreement for Electricians in the Construction Product Industry",
    "labelSv": "Kollektivavtal för elektriker inom byggproduktindustrin"
  },
  {
    "code": 209,
    "labelFi": "Tullaajien ja huolintatyönjohtajien työehtosopimus",
    "labelEn": "Collective Agreement for Customs Brokers and Freight Forwarding Supervisors",
    "labelSv": "Kollektivavtal för förtullare och speditionsarbetsledare"
  },
  {
    "code": 210,
    "labelFi": "Tekstiilihuoltoalan toimihenkilöitä koskeva työehtosopimus",
    "labelEn": "Collective Agreement for Salaried Employees in the Textile Care Sector",
    "labelSv": "Kollektivavtal för tjänstemän inom textilvårdsbranschen"
  },
  {
    "code": 211,
    "labelFi": "Suorajakelua koskeva työehtosopimus",
    "labelEn": "Collective Agreement for the Delivery of Unaddressed Direct Mail",
    "labelSv": "Kollektivavtal för direktutdelning"
  },
  {
    "code": 212,
    "labelFi": "Partiotyönantajia koskeva työehtosopimus",
    "labelEn": "Collective agreement for Scout associations as employers",
    "labelSv": "Kollektivavtal för scoutarbetsgivare"
  },
  {
    "code": 213,
    "labelFi": "Rautatiealan toimihenkilöitä koskeva työehtosopimus",
    "labelEn": "Collective agreement for salaried employees in the rail sector",
    "labelSv": "Kollektivavtal för tjänstemän inom järnvägsbranschen"
  },
  {
    "code": 214,
    "labelFi": "Satama-alan työehtosopimus",
    "labelEn": "Collective Agreement for the Ports Sector",
    "labelSv": "Kollektivavtal för hamnbranschen"
  },
  {
    "code": 215,
    "labelFi": "Urheiluseuroja koskeva liityntäpöytäkirja",
    "labelEn": "Protocol on adherence for sports associations",
    "labelSv": "Anslutningsprotokoll gällande idrottsföreningar"
  },
  {
    "code": 216,
    "labelFi": "Teknologiateollisuuden työntekijät työehtosopimus",
    "labelEn": "Collective agreement for employees in technology industry",
    "labelSv": "Kollektivavtal för arbetstagare inom teknologiindustrin"
  },
  {
    "code": 217,
    "labelFi": "Hirsitaloteollisuuden työehtosopimus",
    "labelEn": "Collective Agreement for the Log House Industry",
    "labelSv": "Kollektivavtal för timmerhusindustrin"
  },
  {
    "code": 218,
    "labelFi": "Hirsitaloteollisuuden toimihenkilöiden työehtosopimus",
    "labelEn": "Collective Agreement for Salaried Employees in the Log House Industry",
    "labelSv": "Kollektivavtal för tjänstemän inom timmerhusindustrin"
  },
  {
    "code": 219,
    "labelFi": "Metsäkonealan toimihenkilöiden työehtosopimus",
    "labelEn": "Collective Agreement for Salaried Employees in the Forest Machinery sector",
    "labelSv": "Kollektivavtal för tjänstemän inom skogsmaskinbranschen"
  },
  {
    "code": 220,
    "labelFi": "Matkailu-, ravintola- ja vapaa-ajan palveluita koskeva työehtosopimus – esihenkilöt",
    "labelEn": "Collective agreement for supervisors in hotel, restaurant and leisure industry ",
    "labelSv": "Kollektivavtal för chefer i branschen för turism-, restaurang- och fritidstjänster"
  },
  {
    "code": 221,
    "labelFi": "Kaupan logistiikan esihenkilöiden työehtosopimus ",
    "labelEn": "Collective Agreement for Supervisors in Trade Logistics",
    "labelSv": "Kollektivavtal för chefer inom logistik inom handeln"
  },
  {
    "code": 222,
    "labelFi": "Vähittäiskaupan esihenkilöiden työehtosopimus",
    "labelEn": "Collective agreement for retail supervisors",
    "labelSv": "Kollektivavtal för chefer inom detaljhandeln"
  },
  {
    "code": 223,
    "labelFi": "Henkilöstöalan työehtosopimus ",
    "labelEn": "Collective Agreement for Employment Industry",
    "labelSv": "Kollektivavtal för personalbranschen"
  },
  {
    "code": 224,
    "labelFi": "Ammattikorkeakoulujen työehtosopimus",
    "labelEn": "Collective Agreement for Universities of Applied Sciences",
    "labelSv": "Kollektivavtal för yrkeshögskolor"
  }
];